import React, { FC, Suspense } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import styled from "styled-components";
import { ContactModal, ContactModelProps } from "common";
import { Outlet } from "react-router-dom";

const Root = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #fff;
`;
const Body = styled.div`
  display: flex;
`;

export interface HomeLayoutProps extends Pick<ContactModelProps, "onCreateContactMessage"> {
  // children: ReactNode;
}

export const HomeLayout: FC<HomeLayoutProps> = ({ onCreateContactMessage }) => {
  return (
    <Root>
      <Navbar />
      <Body>
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet/>
        </Suspense>
      </Body>
      <Footer />
      <ContactModal  {...{ onCreateContactMessage }}/>
    </Root>
  );
};
